import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'ย้อนกลับ',
      changePassword: 'เปลี่ยนรหัสผ่าน',
      copiedVaultId: 'คัดลอกแล้ว!',
      copyVaultID: 'คัดลอก ID Vault',
      create: 'สร้างใหม่',
      next: 'ถัดไป',
      notSure: 'ฉันไม่แน่ใจ',
      signUp: 'สมัครสมาชิก',
      submit: 'ส่ง',
      updatePassword: 'อัปเดตรหัสผ่าน',
    },
    Errors: {
      createReportFailed: 'สร้างรายงานไม่สำเร็จ',
    },
    ReportStatus: {
      CLOSED: 'ปิดเรื่องแล้ว',
      INVESTIGATING: 'กำลังสืบสวน',
      NEW: 'ส่งแล้ว',
      READ: 'อ่านแล้ว',
    },
    general: {
      navbar: {
        caseSettings: 'การตั้งค่าเคส',
        changePassword: 'เปลี่ยนรหัสผ่าน',
        logOut: 'ออกจากระบบ',
        notifications: 'การแจ้งเตือน',
        notificationsDrawer: {
          appFileScanFailed: 'ไฟล์ไม่ผ่านการตรวจสอบความปลอดภัย',
          appReportMatch: 'บันทึก GoTogether ของคุณถูกจับคู่แล้ว',
          appReportReassigned: 'ได้มอบหมายผู้จัดการเคสใหม่',
          case: 'กรณี',
          caseAssigned: 'คดีที่ได้รับมอบหมายให้คุณ',
          caseImporterJobCompleted: {
            PartialSuccess: 'การนำเข้าข้อมูลของคุณเสร็จสิ้นแต่มีข้อผิดพลาด',
            failure: 'การนำเข้าข้อมูลของคุณล้มเหลว',
            success: 'การนำเข้าข้อมูลของคุณสำเร็จแล้ว',
          },
          caseLinked: 'กรณีที่เชื่อมโยง',
          caseTeamInvite: 'เพิ่มเข้าไปในกรณี',
          caseUnlinked: 'กรณีไม่เชื่อมโยง',
          dataSanitisation: 'รายละเอียดรายงานถูกอัปเดต',
          emptyDescription: 'ตรวจสอบใหม่ทีหลังสำหรับการแจ้งเตือนใหม่ๆ',
          emptyTitle: 'คุณได้อ่านทั้งหมดแล้ว',
          importId: 'ID นำเข้า:',
          learnMore: 'เรียนรู้เพิ่มเติม',
          markAllAsRead: 'ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว',
          newMessage: 'ข้อความใหม่',
          newReport: 'รับรายงานใหม่แล้ว',
          permissionRemoved: 'ถูกนำออกจากกรณี',
          postSSubmissionFile: 'ไฟล์หลักฐานถูกเพิ่มเข้ามา',
          report: 'รายงาน',
          reportAssigned: 'รายงานที่มอบหมายให้คุณ',
          reportStatusChange: 'สถานะรายงานเปลี่ยนแปลง',
          reporterAnonymised: 'รายละเอียดของคุณได้รับการทำให้เป็นนิรนามแล้ว',
          reporterReportSubmitted: {
            subtitle: 'เราขอแนะนำให้คัดลอกรายงานของคุณไว้',
            title: 'รายงานที่ส่งมา',
          },
          mitigationPlanReminder: 'ต้องการการอนุมัติแผนบรรเทาผลกระทบ',
          staleCase: 'กรณีที่ไม่ได้ดำเนินการ',
        },
        privacyStatement: 'คำปฏิญญาความเป็นส่วนตัว',
        reporter: {
          myReports: 'รายงานของฉัน',
        },
        settings: 'การตั้งค่า',
        technicalSupport: 'การสนับสนุนทางเทคนิค',
        title: 'บัญชี',
      },
      time: {
        day: 'วัน',
        days: 'วันที่',
        hour: 'ชั่วโมง',
        hours: 'ชั่วโมง',
        minute: 'นาที',
        minutes: 'นาที',
        second: 'ที่สอง',
        seconds: 'วินาที',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'ไม่ระบุชื่อ',
        autoTranslate: 'การแปลอัตโนมัติถูกปิดไว้เป็นค่าเริ่มต้น',
        backToMessages: 'ย้อนกลับไปที่ข้อความ',
        caseSettings: 'การตั้งค่ากรณี.',
        changeInProfile:
          'ถ้าคุณต้องการเปลี่ยนการตั้งค่านี้ คุณสามารถทำได้ในโปรไฟล์ของคุณ',
        deletedByMessage: 'ลบโดย {{author}}',
        deletedMessageLabel: 'ข้อความนี้ถูกลบแล้ว',
        description:
          'เมื่อเปิดใช้งานการแปลอัตโนมัติ ข้อความทั้งหมดในรายงานจะถูกแปลโดยอัตโนมัติโดยใช้ AI ขึ้นอยู่กับภาษาเริ่มต้นที่เลือกในเบราว์เซอร์ของคุณ',
        descriptionSecondHalf:
          'เวอร์ชันต้นฉบับของข้อความทั้งหมดจะถูกเก็บรักษาเสมอและสามารถค้นหาได้ในการแชท',
        messagePlaceholder: 'เริ่มพิมพ์...',
        messageSettings: 'การตั้งค่าข้อความ.',
        originalMessages:
          'ขออภัย, คุณไม่ได้ให้ข้อความที่ต้องการแปล. กรุณาให้ข้อความใหม่.',
        showMoreBanner: 'เรียนรู้เพิ่มเติมเกี่ยวกับการแปลโดยอัตโนมัติ',
        titlev2: 'อ่านข้อความทั้งหมดในภาษาที่คุณชอบ',
        translatedMessageLabel: 'ข้อความที่แปล',
        translatedMessages: 'แปลภาษา',
        understood: 'เข้าใจ',
      },
      Country: {
        description: 'คุณทำงานในประเทศใด?',
        header: 'คุณทำงานในประเทศใด?',
        noOptions: 'ไม่พบประเทศ',
        other: 'อื่นๆ',
        placeholder: 'ค้นหาประเทศ...',
      },
      CreatePublicReport: {
        createReport: 'สร้างรายงานใหม่',
        helpPage: 'ไปที่หน้าช่วยเหลือของเรา',
        loginToOpr: 'เข้าสู่ระบบเพื่อติดตามรายงาน',
        or: 'หรือ',
        passwordPlaceholder: 'ป้อนรหัสผ่าน',
        phoneNumberLoginFailed:
          'การเข้าสู่ระบบล้มเหลว, เลขที่โทรศัพท์/รหัส PIN ไม่ถูกต้อง',
        phoneNumberPlaceholder: 'กรอกหมายเลขโทรศัพท์ของคุณ',
        phoneNumberTooltip: 'ใส่หมายเลขโทรศัพท์ที่คุณใช้ติดต่อ VaultTalk',
        pinPlaceholder: 'ใส่รหัส PIN',
        reportIntroductionParagraph1:
          'เมื่อรายงานเหตุการณ์ คุณจะถูกถามคำถามหลายคำเพื่อสนับสนุนคุณในการทำเอกสารประสบการณ์ของคุณ',
        reportIntroductionParagraph2:
          'ก่อนที่คุณจะส่งคำตอบ คุณมีตัวเลือกในการไม่เปิดเผยตัวตนเพื่อคุ้มครองความเป็นส่วนตัวของคุณ',
        reportIntroductionParagraph3:
          'หลังจากที่คุณส่งแล้ว คุณสามารถเข้าสู่ระบบได้ทุกเวลาเพื่อดูความคืบหน้าของรายงานของคุณและพูดคุยกับผู้จัดการเคส',
        reportIssue: 'รายงานปัญหา',
        usernameLoginFailed: 'เข้าสู่ระบบล้มเหลว ชื่อผู้ใช้/รหัสผ่านไม่ถูกต้อง',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'ต้องระบุความสัมพันธ์กับบริษัท',
            reportedCategoryRequired: 'ต้องระบุหมวดหมู่ที่รายงาน',
          },
        },
        vaultId: 'Vault ไอดี',
        vaultIdPlaceholder: 'ป้อนอีเมลของคุณหรือ ID ของ Vault',
        vaultIdTooltip:
          'สำหรับรายงานที่ไม่ระบุชื่อ รหัส Vault เป็นตัวอักษรและตัวเลข หากรายงานไม่ได้เป็นการไม่ระบุชื่อ รหัส Vault คือที่อยู่อีเมลของคุณ',
        vaultTalk: 'VaultTalk',
        yourPassword: 'รหัสผ่านของคุณ',
        yourPhoneNumber: 'หมายเลขโทรศัพท์ของคุณ',
        yourPin: 'รหัส PIN 6 หลักของคุณ',
        yourVaultId: 'รหัส Vault ของคุณ',
      },
      CustomHeader: {
        companyLogo: 'โลโก้ของบริษัท',
        openReporting: 'เปิดการรายงาน',
        userSettings: 'การตั้งค่าของผู้ใช้',
      },
      Date: {
        approximateDescription:
          'คุณจำวันที่โดยประมาณที่เกิดเหตุการณ์นี้ได้หรือไม่?',
        approximatePlaceholder:
          'อย่างเช่น: เมื่อ 6 เดือนก่อน / ปีที่แล้ว /  เดือนพฤศจิกายนปีก่อน',
        cancel: 'ยกเลิก',
        clear: 'ล้าง',
        description: 'คุณจำวันที่เกิดเหตุการณ์นี้ได้หรือไม่?',
        header: 'เหตุการณ์นี้เกิดขึ้นวันใด?',
        ok: 'ตกลง',
        placeholder: 'อย่างเช่น: วันที่ 21 มิถุนายน พ.ศ. 2563',
      },
      Description: {
        whatHappened: 'เกิดอะไรขึ้น?',
        whatHappenedPlaceholder: 'ใช้ถ้อยคำของคุณเอง...',
        whatHappenedText: 'อธิบายสิ่งที่เกิดขึ้น โดยใช้ถ้อยคำของคุณเอง',
      },
      Details: {
        disclaimer:
          'รายละเอียดเหล่านี้จะถูกเปิดเผยพร้อมกับรายงานของคุณ หากคุณต้องการที่จะอยู่โดยไม่ระบุชื่อ โปรดตรวจสอบว่าไม่มีข้อมูลที่สามารถระบุตัวคุณได้',
        emailPlaceholder: 'อีเมล (ไม่จำเป็นต้องระบุ)',
        fullNamePlaceholder: 'ชื่อเต็ม (ไม่จำเป็นต้องระบุ)',
        header: 'รายละเอียดของคุณ',
        nonAnonSubtitle:
          'โปรดระบุชื่อหรือที่อยู่อีเมลของคุณ หากคุณต้องการรับการแจ้งเตือนเกี่ยวกับรายงานนี้ โปรดเพิ่มที่อยู่อีเมลที่เหมาะสมด้านล่าง',
        nonOptionalEmailPlaceholder: 'อีเมล์',
        nonOptionalFullNamePlaceholder: 'ชื่อเต็ม',
        subtitle:
          'หากคุณต้องการรับการแจ้งเตือนเกี่ยวกับรายงานนี้ โปรดเพิ่มที่อยู่อีเมลที่เหมาะสมด้านล่าง',
      },
      Emotion: {
        description:
          'คุณรู้สึกอย่างไรกับเหตุการณ์ที่เกิดขึ้นนี้ เหตุการณ์ที่เกิดขึ้นนี้มีผลกระทบอะไรบ้าง?',
        header: 'เหตุการณ์ที่เกิดขึ้นนี้มีผลกระทบอะไรบ้าง?',
        placeholder: 'เริ่มต้นพิมพ์...',
      },
      Evidence: {
        addedHeading: 'เพิ่มแล้ว',
        deletedMessage: 'ถูกลบออกแล้ว',
        deletedStatus: 'ถูกลบแล้ว',
        failedToOpenFileMessage: 'เปิดไฟล์ไม่สำเร็จ โปรดลองอีกครั้ง',
        fileStatuses: {
          infectedUpload: 'ถูกทำเครื่องหมายโดยการตรวจสอบความปลอดภัย',
          passedUpload: 'ผ่านการตรวจสอบความปลอดภัย',
          pendingUpload: 'การตรวจสอบความปลอดภัยกำลังดำเนินการ',
          readyForDownload: 'พร้อมให้ดาวน์โหลด',
        },
        mobileErrorMessage: 'ไฟล์ที่ถูกปัก: ส่งข้อความถึงผู้จัดการเคสของคุณ',
        nameHeading: 'ชื่อ',
        statusHeading: 'สถานะ',
        tableTitle: 'หลักฐาน',
        webErrorMessage:
          'ไฟล์ที่ถูกระบุ: หากไฟล์ของคุณถูกระบุ กรุณาส่งข้อความติดต่อผู้จัดการเคส',
      },
      FileUpload: {
        addFiles: 'เพิ่มไฟล์',
        addMoreFiles: 'เพิ่มไฟล์เพิ่มเติม',
        confirm: 'ยืนยัน',
        description:
          'การเพิ่มไฟล์เป็นหลักฐานสามารถช่วยสนับสนุนประสิทธิภาพในการแก้ไขโดยผู้จัดการเคสของคุณ โปรดพิจารณาเนื้อหาของไฟล์ (รวมถึงข้อมูลเมตาดาต้าของไฟล์) หากคุณต้องการที่จะเป็นนิรนาม โปรดเคารพสิทธิของบุคคลอื่น ๆ และกฎหมายที่เกี่ยวข้อง',
        dragDrop: 'วางไฟล์ที่นี่หรือ',
        errorMessage:
          'ไฟล์(รายการ) ล้มเหลวเนื่องจากข้อผิดพลาดในเครือข่าย คลิกด้านล่างเพื่อส่งข้อความถึงผู้จัดการของคุณเพื่อขอความช่วยเหลือ',
        fileLimit: 'ขนาดไฟล์สูงสุดของแต่ละไฟล์: 100MB',
        fileUploadLimitText: 'คุณสามารถอัปโหลดไฟล์ได้เพียง 10 ไฟล์เท่านั้น',
        header: 'เพิ่มหลักฐาน',
        helpArticle: 'บทความช่วยเหลือ',
        highlighted: 'เรียกดูไฟล์',
        information: 'ประเภทไฟล์ที่รองรับ',
        moreInformation:
          'สำหรับข้อมูลเพิ่มเติม โปรดดูที่นี่ <a>บทความช่วยเหลือ</a>',
        postSubmissionErrorMessage:
          "เราไม่สามารถอัปโหลดไฟล์ของคุณได้เนื่องจากข้อผิดพลาดของระบบ กรุณาเลือก 'ยืนยัน' อีกครั้ง",
        tooltipAudio: 'เสียง:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'เอกสาร:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'ภาพ:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'ข้อความ:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'วิดีโอ:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'ไฟล์มีขนาดใหญ่เกินไป',
          invalidFileType: 'ประเภทไฟล์ที่ไม่รองรับ: {{extension}}',
          systemError: 'ข้อผิดพลาดของระบบ',
          tooManyFiles: 'จำนวนไฟล์สูงสุดคือ {{maxFiles}}',
        },
        uploadFiles: 'อัปโหลดไฟล์',
      },
      Loading: {
        loading:
          'กรุณารอสักครู่ในขณะที่เราทำการส่งรายงานของคุณไปยังผู้จัดการเคส...',
        postSubmissionLoading: 'กรุณารอสักครู่ในขณะที่เราส่งไฟล์ของคุณ...',
      },
      Location: {
        description: 'เหตุการณ์นี้เกิดขึ้นที่ใด?',
        header: 'เหตุการณ์นี้เกิดขึ้นที่ใด?',
        placeholder: 'อย่างเช่น: ในสำนักงาน',
      },
      MessageListBox: {
        messageCaseManager: 'ส่งข้อความถึงผู้จัดการเคสของคุณ',
        report: 'รายงาน {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'การแปลถูกปิดใช้งาน',
        enableTranslationLabelEnabled: 'การแปลถูกเปิดใช้งาน',
        enableTranslationsDescription:
          'เปิดใช้งานการแปลอัตโนมัติและอ่านข้อความรายงานทั้งหมดในภาษาที่คุณโปรดปราน. ภาษาที่แปลจะขึ้นอยู่กับภาษาที่คุณเลือกในอุปกรณ์ของคุณ.',
        enableTranslationsHeader:
          'เปิดใช้งานการแปลอัตโนมัติสำหรับข้อความรายงาน',
        enableTranslationsSubDescriptionv2:
          'คุณสามารถสลับระหว่างภาษาที่แปลและภาษาต้นฉบับในแต่ละการแชท',
        updateTranslationFailed: 'การอัปเดตการแปลล้มเหลว',
        updateTranslationSuccess: 'การตั้งค่าการแปลอัปเดตเรียบร้อยแล้ว',
      },
      Password: {
        changePasswordHeader: 'เปลี่ยนรหัสผ่าน',
        createNewPassword: 'กรุณาตั้งรหัสผ่านใหม่',
        createPasswordHeader: 'รหัสผ่านของคุณ',
        currentPasswordPlaceholder: 'ป้อนรหัสผ่านปัจจุบัน',
        description:
          'รหัสผ่านที่ใช้งานได้ต้องมีความยาวอย่างน้อย 9 ตัว และประกอบด้วยอักษรตัวพิมพ์ใหญ่ 1 ตัว และตัวเลข 1 ตัว',
        enterCurrentPassword: 'กรุณาป้อนรหัสผ่านปัจจุบันของคุณ',
        forgottenPasswordInstructions:
          'ป้อน ID Vault ที่เป็นตัวอักษรและตัวเลขของคุณ (ไม่ใช่ที่อยู่อีเมลของคุณ) และที่อยู่อีเมลเพื่อรีเซ็ตรหัสผ่านของคุณ',
        newDescription:
          'สร้างรหัสผ่านที่มั่นคงเพื่อรักษาความปลอดภัยให้กับบัญชีของคุณ กรอกข้อความเพื่อดูคำแนะนำที่ด้านล่าง',
        passwordPlaceholder: 'ตั้งรหัสผ่าน',
        passwordResetRequestedDescription:
          'ถ้า Vault ID ของคุณมีอยู่ในระบบของเรา คุณจะได้รับอีเมลที่มีคำแนะนำเกี่ยวกับวิธีการตั้งค่ารหัสผ่านใหม่',
        passwordResetRequestedHeader: 'ลิ้งค์สำหรับรีเซ็ตรหัสผ่านถูกขอให้',
        reenterPlaceholder: 'ป้อนรหัสผ่านอีกครั้ง',
        subtitle: 'ตั้งรหัสผ่านเพื่อส่งรายงานนี้ และเข้าถึงรายงานนี้ในอนาคต',
        yourVaultId: 'Vault ไอดีของคุณ',
        yourVaultIdPlaceholder: 'ป้อน Vault ID ของคุณ (เช่น {{exampleId}})',
      },
      Perpetrators: {
        description:
          'คุณกำลังรายงานบุคคลที่เฉพาะเจาะจงหรือรายงานหลายคน คุณสามารถระบุชื่อหรืออธิบายรูปพรรณสันฐานของพวกเขาได้หรือไม่?',
        header: 'ผู้ที่เกี่ยวข้อง',
        placeholder:
          'เริ่มต้นพิมพ์และใช้เครื่องหมายจุลภาพ (,) เพื่อคั่นแต่ละชื่อหรือคำอธิบาย',
      },
      PoweredByVault: 'ให้บริการโดย {{company}}',
      PrivacyStatement: 'คำประกาศความเป็นส่วนตัวของสินค้า',
      PublicMessageList: {
        myMessages: 'ข้อความของฉัน',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'เพิ่มหลักฐานในรายงานที่มีอยู่แล้ว',
        backToReportId: 'กลับไปที่รายงาน ID: {{reportId}}',
        description:
          'การเพิ่มไฟล์เป็นหลักฐานสามารถช่วยสนับสนุนประสิทธิภาพในการแก้ไขปัญหาโดยผู้จัดการของคุณ โปรดพิจารณาเนื้อหาของไฟล์ (รวมถึงข้อมูลเมตาของไฟล์) หากคุณต้องการที่จะเก็บตัวตนให้ไม่รู้จัก และเคารพสิทธิของบุคคลอื่นๆ และกฎหมายที่เกี่ยวข้อง สำหรับข้อมูลเพิ่มเติม กรุณาดูที่นี่ <a>บทความช่วยเหลือ</a>',
        header: 'เพิ่มหลักฐานเพิ่มเติมในรายงาน',
        vaultTalkOpenCaseHeader: 'เพิ่มหลักฐานในรายงานของคุณ',
      },
      PublicReport: {
        anonymous: 'ไม่ระบุชื่อ',
        backToReports: 'ย้อนกลับไปที่รายงาน',
        skipped: 'ข้ามแล้ว',
      },
      PublicReportCard: {
        addEvidence: 'เพิ่มหลักฐานเพิ่มเติม',
        messageCaseManager: 'ส่งข้อความถึงผู้จัดการเคสของคุณ',
        reportId: 'ID ของรายงาน: ',
        submitted: 'ส่งแล้ว',
        vaultTalkClosedCaseCTA: 'ดูหลักฐาน',
        vaultTalkOpenCaseCTA: 'เพิ่มหลักฐาน',
        viewAdditionalEvidence: 'ดูหลักฐานเพิ่มเติม',
        viewReport: 'เรียกดูรายงาน',
      },
      PublicReportsList: {
        reportingSystem: 'ระบบการรายงาน',
      },
      Question: {
        placeholder: 'เริ่มพิมพ์...',
        question: 'ให้รายละเอียด',
        questionText:
          'กรุณาแบ่งปันข้อกังวล, การอัปเดต, หรือการสอบถามของคุณกับเรา',
      },
      Relationship: {
        header: 'ความสัมพันธ์ของคุณกับองค์กรนี้',
        tellUsAbout: 'กรุณาบอกเราเกี่ยวกับความสัมพันธ์ของคุณกับองค์กรนี้',
      },
      ResponsiveNavMenu: {
        messages: 'ข้อความของฉัน',
        reports: 'รายงานของฉัน',
      },
      Site: {
        description: 'คุณทำงานที่ไซต์ใด?',
        header: 'คุณทำงานที่ไซต์ใด?',
        noOptions: 'ไม่พบไซต์',
        other: 'อื่นๆ',
        placeholder: 'ค้นหาไซต์...',
      },
      SpamPuzzle: {
        dialog: 'หากต้องการดำเนินการต่อ กรุณาแก้ปริศนานี้',
      },
      SubmissionTypes: {
        reportIssue: 'เลือกหมวดหมู่',
        whatType: 'เลือกหมวดหมู่ที่อธิบายรายงานของคุณได้ดีที่สุด',
      },
      SubmitSuccess: {
        category: '<bold>หมวดหมู่:</bold> {{category}}',
        country: '<bold>ประเทศ:</bold> {{country}}',
        dateSubmitted: '<bold>วันที่ส่ง:</bold> {{date}}',
        recordYourVaultID: 'จำข้อมูลนี้สำหรับการเข้าสู่ระบบ',
        successInformation: 'ข้อมูลเพิ่มเติม',
        successMessage:
          'รายงานของคุณได้รับการส่งแล้วและพร้อมสำหรับการตรวจสอบ ไฟล์ที่แนบมาที่ต้องการความสนใจจะถูกทำเครื่องหมายเมื่อคุณเข้าสู่ระบบ ลงชื่อเข้าใช้ด้านล่างเพื่อดูการอัปเดตรายงานและส่งข้อความถึงผู้จัดการของคุณ',
        successSanitationMessage:
          'บันทึกสำเนาไว้สำหรับบันทึกของคุณ และเก็บ Vault-ID ของคุณไว้ให้ปลอดภัย - คุณจะต้องใช้มันเพื่อเข้าถึงการอัปเดตและส่งข้อความให้ผู้จัดการเคสของคุณ',
        successSanitationTagline: 'รายงานของคุณถูกส่งและจัดเก็บอย่างปลอดภัย',
        successThankYou: 'ขอบคุณสำหรับรายงานของคุณ!',
        viewReport: 'ดูรายงาน',
      },
      Time: {
        approximateDescription:
          'คุณจำเวลาโดยประมาณที่เกิดเหตุการณ์นี้ได้หรือไม่?',
        approximatePlaceholder: 'อย่างเช่น: ในตอนเช้า ในตอนบ่าย',
        description: 'คุณจำเวลาที่เกิดเหตุการณ์นี้ได้หรือไม่?',
        header: 'เหตุการณ์นี้เกิดขึ้นในเวลาใด?',
        invalidTime: 'รูปแบบของเวลาต้องเป็น ชช:นน',
      },
      UserSettingsDialog: {
        changePassword: 'เปลี่ยนรหัสผ่าน',
        closeDialog: 'ปิดกล่องโต้ตอบ',
        logout: 'ออกจากระบบ',
        messageSettings: 'การตั้งค่าข้อความ',
        userSettings: 'การตั้งค่าของผู้ใช้',
      },
      Witnesses: {
        description:
          'คุณได้บอกกับคนอื่น หรือมีใครเห็นเหตุการณ์ที่เกิดขึ้นนี้หรือไม่?',
        header: 'มีพยานรู้เห็นหรือไม่?',
        placeholder: 'เริ่มต้นพิมพ์...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'ส่งข้อความ',
        title: 'ข้อความจากผู้จัดการกรณี',
        translationHeader: 'เรียนรู้เพิ่มเติมเกี่ยวกับการแปลอัตโนมัติ',
      },
      ReportCard: {
        addEvidence: 'เพิ่มหลักฐาน',
        submissionModeVia: 'ผ่าน {{submissionMode}}',
        viewEvidence: 'ดูหลักฐาน',
      },
      ReportList: {
        yourReports: 'รายงานของคุณ',
      },
      ReportingActivate: {
        buttonText: 'ดำเนินต่อ',
        description:
          'หากองค์กรของคุณได้ลงทะเบียนให้คุณสำหรับบัญชีผู้ใช้ เราจะส่งอีเมลถึงคุณพร้อมคำแนะนำเพื่อการตั้งค่าครบถ้วน',
        emailInput: 'อีเมล',
        header: 'ป้อนอีเมลที่ทำงานของคุณ',
        successAccount:
          'ถ้าองค์กรของคุณได้ลงทะเบียนเพื่อให้คุณสร้างบัญชี พวกเราจะส่งอีเมลให้คุณพร้อมกับคำแนะนำเกี่ยวกับวิธีการตั้งค่าเสร็จสิ้น',
        successEmail:
          'ถ้าคุณไม่เห็นทันที โปรดรอสักครู่และรีเฟรชกล่องข้อความอีเมลของคุณ',
        successHeading: 'ขอบคุณคุณ',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'เพิ่มหลักฐานในรายงานของคุณ',
        descriptionText:
          'การเพิ่มไฟล์เป็นหลักฐานสามารถช่วยสนับสนุนประสิทธิภาพในการแก้ไขโดยผู้จัดการเคสของคุณ โปรดพิจารณาเนื้อหาไฟล์ (รวมถึงข้อมูลเมตาดาต้าของไฟล์) ถ้าคุณต้องการที่จะเป็นคนไม่ทราบชื่อ และต้องเคารพสิทธิ์ของบุคคลอื่น ๆ และกฎหมายที่มีผลบังคับใช้ สำหรับข้อมูลเพิ่มเติมโปรดดูบทความช่วยเหลือนี้ <a>บทความช่วยเหลือ</a>',
        emptyMessage: 'ไม่มีหลักฐานเพิ่มเติมที่อัปโหลด',
      },
      ReportingChangePassword: {
        back: 'กลับ',
        description:
          'สร้างรหัสผ่านที่มั่นคงเพื่อรักษาความปลอดภัยให้กับบัญชีของคุณ ให้เริ่มการพิมพ์เพื่อดูคำแนะนำที่ด้านล่าง',
        errorToast: 'ไม่สามารถสร้างรหัสผ่านได้, โทเค็นไม่ถูกต้อง.',
        header: 'เปลี่ยนรหัสผ่าน',
        incorrectCurrentPassword:
          'รหัสผ่านปัจจุบันไม่ถูกต้อง โปรดตรวจสอบและลองใหม่อีกครั้ง',
        invalidToken: 'โทเค็นไม่ถูกต้อง',
        passwordUpdated: 'รหัสผ่านถูกอัปเดตแล้ว',
        passwordUpdatedDescription:
          'รหัสผ่านของคุณได้รับการอัปเดตเรียบร้อยแล้ว ขอบคุณที่ได้ทำขั้นตอนนี้เพื่อรักษาความปลอดภัยของข้อมูลของคุณ!',
        passwordUsedBefore: 'ไม่อนุญาตให้ใช้รหัสผ่านซ้ำ',
        passwordUsedBeforeDescription:
          'เพื่อความปลอดภัยของคุณ คุณไม่สามารถใช้รหัสผ่านสุดท้ายหกตัวที่คุณใช้มาอีกได้ กรุณาเลือกรหัสผ่านใหม่ที่ไม่ซ้ำเพื่อรักษาความปลอดภัยของบัญชีของคุณ และลองอีกครั้ง',
        toastDescription:
          'รหัสผ่านของคุณได้รับการอัปเดตเรียบร้อยแล้ว ขอบคุณที่ใช้ขั้นตอนนี้ในการรักษาความปลอดภัยของข้อมูลของคุณ!',
        toastMessage: 'รหัสผ่านได้รับการอัปเดตแล้ว',
        updatePasswordCTA: 'อัปเดตรหัสผ่าน',
      },
      ReportingConnect: {
        cancelButton: 'ยกเลิก',
        connectButton: 'เชื่อมต่อ',
        disclaimer:
          'การเชื่อมต่อบัญชี Slack ของคุณกับบัญชี Vault จะช่วยให้การเชื่อมต่อของคุณมั่นคงและเป็นส่วนตัว<br /><br />การเชื่อมต่อจะทำให้คุณสามารถรายงานการประพฤติไม่เหมาะสมหรือถามคำถามโดยตรงภายใน Slack คุณจะมีตัวเลือกเสมอในการรายงานโดยไม่เปิดเผยชื่อหลังจากการเชื่อมต่อ ความเป็นส่วนตัวและความมั่นคงของคุณเป็นลำดับความสำคัญสูงสุดของเรา',
        heading:
          'Vault Platform ขอร้องขอสิทธิ์ในการเข้าถึงบัญชี Slack ของ{{organisationName}} ของคุณ',
        listHeading: 'Vault จะสามารถทำอะไรได้บ้าง?',
        permissionIdentity: {
          extraInfo: 'Vault จะมีความสามารถในการดูตัวตนของผู้ใช้ Slack ของคุณ',
          heading: 'ดูข้อมูลเกี่ยวกับตัวตนของผู้ใช้',
        },
        permissionNotifications: {
          extraInfo:
            'Vault จะสามารถส่งการแจ้งเตือนให้คุณผ่านบัญชี Slack ของคุณ เกี่ยวกับการอัปเดตใด ๆ ที่เกิดขึ้นกับรายงานหรือคำถามที่ท่านได้ส่งไป',
          heading: 'ส่งการแจ้งเตือนถึงคุณ',
        },
        permissionOverview: {
          extraInfo: 'Vault จะแสดงภาพรวมของการส่งทั้งหมดในหน้าแรก',
          heading: 'ภาพรวมของการส่งเข้า',
        },
        permissionSubmitReport: {
          extraInfo:
            'นี่จะให้สิทธิ์แก่ Vault ในการส่งรายงานหรือถามคำถามโดยตรงไปยังองค์กรของคุณ จาก Slack',
          heading: 'ส่งรายงานหรือคำถามในนามของคุณ',
        },
        successfulConnectionDescription:
          'บัญชี Vault และบัญชี Slack ของคุณได้ถูกเชื่อมต่อแล้ว คุณสามารถปิดแท็บนี้แล้วกลับไปที่ Slack',
        successfulConnectionHeading: 'เชื่อมต่อสำเร็จแล้ว',
        unsuccessfulConnectionDescription:
          'มีบางอย่างผิดพลาด โปรดปิดแท็บนี้และกลับไปที่ Slack เพื่อลองใหม่อีกครั้ง',
        unsuccessfulConnectionHeading: 'การเชื่อมต่อล้มเหลว',
      },
      ReportingForgotPassword: {
        description:
          'กรอกที่อยู่อีเมลที่เชื่อมโยงกับบัญชีของคุณ และเราจะส่งลิงค์ให้คุณเพื่อรีเซ็ตรหัสผ่านของคุณ',
        heading: 'ลืมรหัสผ่าน',
        invalidTokenError: 'ไม่สามารถสร้างรหัสผ่านได้, โทเค็นไม่ถูกต้อง.',
        passwordReuseError: 'ไม่อนุญาตให้ใช้รหัสผ่านซ้ำ',
        passwordReuseErrorDescription:
          'เพื่อความปลอดภัยของคุณ คุณไม่สามารถใช้รหัสผ่านที่คุณใช้ไปแล้วในหกครั้งที่แล้ว กรุณาเลือกรหัสผ่านใหม่ที่ไม่ซ้ำเพื่อรักษาความปลอดภัยบัญชีของคุณและลองอีกครั้ง',
        sendLink: 'ส่งลิงก์รีเซ็ต',
        sendLinkFailure: 'บางอย่างผิดพลาด',
        sendLinkFailureDescription:
          'กลับไปที่<a>ศูนย์รายงาน</a> แล้วลองอีกครั้ง หากปัญหายังคงมีอยู่ ติดต่อเราที่ <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'ลิงค์สำหรับตั้งรหัสผ่านใหม่ถูกส่งแล้ว',
        sendLinkSuccessDescription:
          'เราได้ส่งลิงก์เพื่อรีเซ็ตรหัสผ่านไปยัง {{email}}',
        updatePasswordSuccess: 'รหัสผ่านได้รับการอัปเดตแล้ว',
        updatePasswordSuccessDescription:
          'รหัสผ่านของคุณได้รับการอัปเดตเรียบร้อยแล้ว ขอบคุณที่ทำขั้นตอนนี้เพื่อรักษาข้อมูลของคุณให้ปลอดภัย!',
      },
      ReportingLogin: {
        accountFrozen: 'บัญชีถูกแชลโม่',
        accountLocked:
          'การล็อกอินถูกพยายามมากเกินไปในการเข้าสู่ระบบอย่างไม่ถูกต้อง บัญชีนี้ถูกล็อคไว้สูงสุด 1 ชั่วโมง ไม่สามารถรีเซ็ตรหัสผ่านได้ในช่วงเวลานี้',
        accountLockedPermanently:
          'บัญชีของคุณถูกล็อคแล้ว ใช้การรีเซ็ตรหัสผ่านเพื่อเรียกคืนการเข้าถึงหรือติดต่อผู้ดูแลระบบของคุณเพื่อขอความช่วยเหลือเพิ่มเติม',
        createAccountCTA: 'ลงทะเบียนสำหรับบัญชี',
        currentPassword: 'รหัสผ่านปัจจุบัน',
        emailLabel: 'อีเมลของคุณ',
        forgotPassword: 'ลืมรหัสผ่านของคุณหรือไม่?',
        loginButton: 'เข้าสู่ระบบ',
        newPasswordPlaceholder: 'รหัสผ่านใหม่',
        passwordFailMessage:
          'กลับไปที่แอพ Vault ใน Slack แล้วลองอีกครั้ง หากปัญหายังคงมีอยู่ ติดต่อเราที่ techsupport@vaultplatform.com',
        passwordFailTitle: 'มีบางอย่างผิดพลาด',
        passwordLabel: 'รหัสผ่านของคุณ',
        passwordPlaceholder: 'กรอกรหัสผ่านของคุณ',
        passwordResetRequired: 'ต้องการรีเซ็ตรหัสผ่าน',
        passwordSuccessfullySetMessage:
          'กลับไปที่ Vault App ใน Slack และทำการยืนยันตัวตนด้วยรหัสผ่านใหม่ของคุณเพื่อดำเนินการต่อจากที่คุณหยุดไว้',
        passwordSuccessfullySetTitle: 'ตั้งรหัสผ่านสำเร็จแล้ว',
        reenterPlaceholder: 'ป้อนรหัสผ่านอีกครั้ง',
        title: 'ศูนย์รวมข่าวสาร',
        tooltip:
          'ถ้าคุณยังไม่เคยตั้งรหัสผ่านสำหรับแอป Vault ยัง คุณสามารถทำตามที่นี่เพื่อเริ่มต้น หากคุณลืมรหัสผ่านของคุณ ให้ใช้ลิงก์ "ลืมรหัสผ่าน" ด้านล่างนี้',
        usernameLoginFailed:
          'เข้าสู่ระบบไม่สำเร็จ ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
      },
      ReportingReset: {
        failureDescription:
          'กลับไปที่แอป Vault ใน Slack และลองอีกครั้ง หากปัญหายังคงมีอยู่ โปรดติดต่อเราที่ <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'สิ่งบางอย่างผิดพลาด',
        successDescription:
          'กลับไปที่ Vault App ใน Slack และยืนยันตัวตนด้วยรหัสผ่านใหม่ของคุณเพื่อดำเนินการต่อจากที่คุณหยุด',
        successHeading: 'ตั้งรหัสผ่านสำเร็จแล้ว',
      },
      noReports: {
        description:
          'รายงานทั้งหมดที่ส่งเข้ามาจะแสดงที่นี่ ศึกษาเพิ่มเติมเกี่ยวกับวิธีที่คุณสามารถส่งรายงาน',
        descriptionHelpArticle: 'บทความช่วยเหลือนี้',
        errorDescription:
          'เรากำลังมีปัญหาในการโหลดรายงานของคุณ กรุณาลองรีเฟรชหน้านี้',
        errorDescriptionSecondary: 'ถ้าวิธีนั้นไม่ทำงาน โปรดติดต่อเราที่',
        errorTitle: '⚠️ โอ๊ะ มีบางอย่างผิดพลาด',
        title: 'คุณยังไม่มีรายงานใด ๆ',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'เปิดใช้งานการแปลอัตโนมัติและอ่านข้อความรายงานทั้งหมดในภาษาที่คุณต้องการ ภาษาที่แปลจะขึ้นอยู่กับภาษาที่คุณเลือกในอุปกรณ์ของคุณ.',
          autoTranslationDescription2:
            'คุณสามารถสลับระหว่างภาษาที่แปลและภาษาต้นฉบับในแต่ละการแชท',
          autoTranslationTitle: 'เปิดใช้งานการแปลอัตโนมัติสำหรับข้อความรายงาน',
          header: 'การตั้งค่าข้อความ',
          subHeader: 'กำหนดวิธีการแสดงข้อความ',
        },
        notificationSettings: {
          emailDescription:
            'รับการแจ้งเตือนทางอีเมลสำหรับการอัปเดตที่สำคัญในรายงานของคุณ',
          emailTitle: 'การแจ้งเตือนทางอีเมล',
          header: 'การตั้งค่าการแจ้งเตือน',
          subHeader: 'กำหนดวิธีการที่คุณจะรับการแจ้งเตือน',
        },
        title: 'การตั้งค่า',
        updatedSettingsFailure: 'การอัปเดตการตั้งค่าของคุณล้มเหลว',
        updatedSettingsSuccess: 'อัปเดตการตั้งค่าของคุณเรียบร้อยแล้ว',
      },
    },
    validators: {
      passwordLength: 'รหัสผ่านต้องมีความยาวอย่างน้อย 9 ตัว',
      passwordLowercase:
        'รหัสผ่านต้องประกอบด้วยอักษรตัวพิมพ์เล็กอย่างน้อย 1 ตัว',
      passwordMissMatch: 'ค่าที่ป้อนในช่องรหัสผ่านและรหัสผ่านยืนยันต้องตรงกัน',
      passwordNumeric: 'รหัสผ่านต้องประกอบด้วยตัวเลขอย่างน้อย 1 ตัว',
      passwordUppercase:
        'รหัสผ่านต้องประกอบด้วยอักษรตัวพิมพ์ใหญ่อย่างน้อย 1 ตัว',
    },
    validatorsNew: {
      passwordLength: 'ระหว่าง 10 และ 30 ตัวอักษร',
      passwordLowercase: 'อย่างน้อยหนึ่งตัวอักษรตัวเล็ก',
      passwordMissMatch: 'รหัสผ่านไม่ตรงกัน',
      passwordNumeric: 'อย่างน้อยหนึ่งตัวเลข',
      passwordSpecialCharacter: 'อย่างน้อยหนึ่งตัวอักษรพิเศษ',
      passwordUppercase: 'อย่างน้อยหนึ่งตัวอักษรตัวใหญ่',
    },
  },
};

export default translations;
